import React, { useState, Suspense, useMemo, useCallback } from "react";
import { Canvas } from "@react-three/fiber";
import { useProgress } from '@react-three/drei';
// import FPSStats from "react-fps-stats";
import { InfoPointProvider, InfoPoint } from "./InfoPoint";
import { CarShow } from './CarShow';
import "./style.css";

// function toggleFullScreen() {
// 	if (!document.fullscreenElement) {
// 		document.documentElement.requestFullscreen();
// 	} else {
// 		if (document.exitFullscreen) {
// 			document.exitFullscreen();
// 		}
// 	}
// }

function App() {
	const [isRotating] = useState(false);
	const [showInfoPoints] = useState(true);
	const { active, progress, total } = useProgress();
	const infoPoints = useMemo(() => [
		{
			positions: [
				{
					position: [.85, 0.225, 1.507],
					lookingAt: [0, 0.225, 1.507]
				},
				{
					position: [.85, 0.225, -1.2],
					lookingAt: [0, 0.225, -1.2],
				},
				{
					position: [-.85, 0.225, -1.2],
					lookingAt: [0, 0.225, -1.2],
				},
				{
					position: [-.85, 0.225, 1.507],
					lookingAt: [0, 0.225, 1.507],
				},
			],
			info: [
				{
					text: "Reifenservice",
					link: "https://aps-fahrzeugpflege.de/reifenservice/",
				},
				{
					text: "Felgenservice",
					link: "https://aps-fahrzeugpflege.de/felgenservice/",
				},
				{
					text: "CNC-Glanzdrehen",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Bremsen Service",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Bremsattellackierung",
					link: "https://aps-fahrzeugpflege.de/",
				},
			],
		},
		// Punkt 2
		{
			positions: [
				{
					position: [-0.2, 0.81, 1.6],
					lookingAt: [-0.2, -0.83, 1.4],
				},
			],
			info: [
				{
					text: "Motorwäsche",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Service",
					link: "https://aps-fahrzeugpflege.de/",
				},

			],
		},
		// Punkt 3
		{
			positions: [
				{
					position: [0, 1.05, .63],
					lookingAt: [0, 0, -.3],
				},
			],
			info: [
				{
					text: "Glasservice",
					link: "https://aps-fahrzeugpflege.de/autoglasreparatur/",
				},
				{
					text: "Scheiben tönen",
					link: "https://aps-fahrzeugpflege.de/",
				},
			],
		},
		// Punkt 4
		{
			positions: [
				{
					position: [.87, .50, .10],
					lookingAt: [0, .55, .10],
				},
				{
					position: [-.867, .60, 1],
					lookingAt: [0, .50, 1],
				},
				{
					position: [0, .865, -1.9],
					lookingAt: [0, 0, -1.9],
				},
			],
			info: [
				{
					text: "Fahrzeugpflege",
					link: "https://aps-fahrzeugpflege.de/fahrzeugpflege/",
				},
				{
					text: "Smart Repair (Lackarbeiten)",
					link: "https://aps-fahrzeugpflege.de/smartrepair/",
				},
				{
					text: "Smart Repair (Dellentechnik)",
					link: "https://aps-fahrzeugpflege.de/smartrepair/",
				},
				{
					text: "Folierung",
					link: "https://aps-fahrzeugpflege.de/folierung/",
				},
				{
					text: "Highend Veredelung",
					link: "https://aps-fahrzeugpflege.de/high-end-veredlung/",
				},
				{
					text: "Keramikversiegelung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Nano Versiegelung",
					link: "https://aps-fahrzeugpflege.de/",
				},
			],
		},
		// Punkt 5
		{
			positions: [
				{
					position: [.3, .405, 0],
					lookingAt: [.3, 0, .1],
				},
			],
			info: [
				{
					text: "Innenraumreinigung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Polsterreinigung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Lederreinigung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Lederpflege",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Ozonbehandlung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Detailing",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Klimaanlagenreinigung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Innenraumdesinfektion",
					link: "https://aps-fahrzeugpflege.de/",
				},
			],
		},
		// Punkt 6
		{
			positions: [
				{
					position: [.87, .912, .6],
					lookingAt: [0.6, .55, .10],
				},
				{
					position: [-.87, .912, .6],
					lookingAt: [-.1, .15, -.4],
				},
			],
			info: [
				{
					text: "Smart Repair",
					link: "https://aps-fahrzeugpflege.de/smartrepair/",
				},
				{
					text: "Folierung",
					link: "https://aps-fahrzeugpflege.de/folierung/",
				},
			],
			link: "https://aps-fahrzeugpflege.de/smartrepair/",
		},
		// Punkt 7
		{
			positions: [
				{
					position: [0, .915, -1.3],
					lookingAt: [0, 0, -1.3],
				},
			],
			info: [
				{
					text: "Verdeckreinigung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Verdeckimprägnierung",
					link: "https://aps-fahrzeugpflege.de/",
				},
			],
		},
		// Punkt 8
		{
			positions: [
				{
					position: [-.7, .60, 2],
					lookingAt: [0, .50, 1],
				},
				{
					position: [.7, .60, 2],
					lookingAt: [-.2, .50, 1],
				},
				{
					position: [-.642, .73, -2.005],
					lookingAt: [1, .1, 0],
				},
				{
					position: [.64, .73, -2.004],
					lookingAt: [-1, .1, 0],
				},
			],
			info: [
				{
					text: "Scheinwerfer aufarbeiten",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Scheinwerfer versiegeln",
					link: "https://aps-fahrzeugpflege.de/",
				}
			],
		},
		// Punkt 9
		{
			positions: [
				{
					position: [-.2, .255, -.4],
					lookingAt: [-.2, 0, -.406],
				},
			],
			info: [
				{
					text: "Teppichreinigung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Teppichimprägnierung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Teppichaustausch",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Teppichreparatur",
					link: "https://aps-fahrzeugpflege.de/",
				},
			],
		},
		// Punkt 10
		{
			positions: [
				{
					position: [.37, 1, -.251],
					lookingAt: [.365, 1.05, 0],
				},
			],
			info: [
				{
					text: "Leder- und Polsterreparatur",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Lederpflege",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Lederfarbauffrischung",
					link: "https://aps-fahrzeugpflege.de/",
				},
			],
		},
		// Punkt 11
		{
			positions: [
				{
					position: [0, .7, .6],
					lookingAt: [0, .7, 0],
				},
			],
			info: [
				{
					text: "Ozonbehandlung (Geruchsbeseitigung)",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Klimaanlagenreinigung",
					link: "https://aps-fahrzeugpflege.de/",
				},
				{
					text: "Desinfektion",
					link: "https://aps-fahrzeugpflege.de/",
				},
			],
		},
	], []);

	// const toggleRotation = useCallback(() => {
	// 	setIsRotating(!isRotating);
	// }, [isRotating]);

	// const toggleInfoPoints = useCallback(() => {
	// 	setShowInfoPoints(!showInfoPoints);
	// }, [showInfoPoints]);

	return (
		<div className="app">
			{/* <FPSStats top="5px" left="5px" /> */}
			{active && (
				<div className="loading-screen">
					<div className="loading-bar-container">
						<div className="loading-bar" style={{ width: `${((progress / 95) * 100).toFixed(1)}%` }} />
					</div>
					<div className="loading-bar-text">{`${((progress / 95) * 100).toFixed(1)}%`}</div>
				</div>
			)}
			{/* <div className="button-container">
				<img className="rotation-icon rotate" src="rotation.svg" alt="Rotation Icon" onClick={toggleRotation} />
				<img className="infopoint-icon" src="infopoint.svg" alt="InfoPoint Icon" onClick={toggleInfoPoints} />
				<img className="fullscreen-icon" src="fullscreen.svg" alt="Fullscreen Icon" onClick={toggleFullScreen} />
			</div> */}
			<div className="canvas-container">
				<Suspense fallback={null}>
					<Canvas shadows>
						<CarShow isRotating={isRotating} />
						<InfoPointProvider>
							{showInfoPoints &&
								infoPoints.map((point, index) => (
									point.positions.map((position, index) => (
										<InfoPoint
											key={index}
											position={position.position}
											lookingAt={position.lookingAt}
											title={point.title}
											info={point.info}
											link={point.link}
											icon_path={point.icon_path}
											isRotating={isRotating}
											carPosition={[0, 1, 0]}
										/>
									))
								))}
						</InfoPointProvider>
					</Canvas>
				</Suspense>
			</div>
		</div>
	);
}

export default App;
